/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Sorgeberechtigteeltern_Sepamandats2Inputs */



/**

* @param {_Field_Sorgeberechtigteeltern_Sepamandats2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_sorgeberechtigteeltern_sepamandats2 = /** @type {((inputs?: _Field_Sorgeberechtigteeltern_Sepamandats2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Sorgeberechtigteeltern_Sepamandats2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Sorgeberechtigte Eltern > SEPA Mandate")
});
export { _field_sorgeberechtigteeltern_sepamandats2 as "_field_sorgeberechtigteEltern_sepaMandats" }